import { ResultsCount } from "../../results-count/ResultsCount";
import ActionsBar from "../actions-bar/ActionsBar";
import { BulkActionProps } from "../types";
import { SearchResultsInnerComponentProps } from "@kaltura/mediaspace-shared-search";
import { BulkActionMenuItemInjectedProps, FilterValues, KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { ExtraHeaderBaseProps, HeaderBaseProps } from "@kaltura/mediaspace-shared-media-list";
import { CustomComponent } from "@kaltura/mediaspace-shared-ui";

export interface ResultsHeaderProps extends HeaderBaseProps, Pick<SearchResultsInnerComponentProps, "searchInLabel"> {
    bulkButtonActions?: KmsTypeComponent<any, BulkActionProps>[];
    bulkMenuActions?: KmsTypeComponent<any, BulkActionMenuItemInjectedProps>[];
    filterValues?: FilterValues;
    onAllSelected: (checked: boolean) => void;
    selectedEntries: string[];
    extraHeader?: KmsTypeComponent<any, ExtraHeaderBaseProps>;
}

/**
 * Selectable results Header - displays results count and bulk actions bar
 */
export const ResultsHeader = ({
    entryResults,
    searchInLabel,
    bulkButtonActions,
    bulkMenuActions,
    filterValues,
    onAllSelected,
    onReload,
    selectedEntries,
    extraHeader,
}: ResultsHeaderProps) => {
    return (
        <>
            <ResultsCount
                totalCount={entryResults?.totalCount || 0}
                searchInLabel={searchInLabel}
                selectedCount={selectedEntries.length}
                onChange={onAllSelected}
                selectAllValue={selectedEntries.length === entryResults?.objects.length}
            />
            <ActionsBar
                bulkButtonActions={bulkButtonActions}
                bulkMenuActions={bulkMenuActions}
                entryIds={selectedEntries}
                onInvalidate={onReload}
                filterValues={filterValues}
            />
            {!!extraHeader && (
                <CustomComponent component={extraHeader} onReload={onReload} selectedEntries={selectedEntries} />
            )}
        </>
    );
};

export default ResultsHeader;
